import { http, createConfig } from "wagmi";
import { arbitrum } from "wagmi/chains";
import { injected, walletConnect, coinbaseWallet } from "wagmi/connectors";

// WalletConnect (Reown) Cloud project id — supplied via environment variable.
const WC_PROJECT_ID = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID;
const APP_URL = typeof window !== "undefined" ? window.location.origin : "https://aima.ai";

export const wagmiConfig = createConfig({
    chains: [arbitrum],
    connectors: [
        injected({ shimDisconnect: true }),
        walletConnect({
            projectId: WC_PROJECT_ID,
            showQrModal: true,
            metadata: {
                name: "AIMA",
                description: "AIMA — Restricted Token Sale",
                url: APP_URL,
                icons: [`${APP_URL}/brand/aima-square.png`],
            },
        }),
        coinbaseWallet({ appName: "AIMA" }),
    ],
    transports: {
        [arbitrum.id]: http(),
    },
    ssr: false,
});
